<template>
	<div class="register-form">
		<router-link :to="{ name: 'home' }" class="lineup-home">
			<img class="logo-lineup" src="../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
		</router-link>
		<span class="register-title">Crear mi cuenta</span>
		<div class="input-row input-row-always-1-row">
			<div class="input-group-wrapper input-group-wrapper-100">
				<social-button
					:logo="'@/assets/GoogleLogo.svg'"
					:text="'Google'"
					:url="googleUrl"
				></social-button>
			</div>
			<!-- <div class="input-group-wrapper input-group-wrapper-50">
				<social-button
					:logo="'@/assets/FacebookLogo.svg'"
					:text="'Facebook'"
					:url="facebookUrl"
				></social-button>
			</div> -->
		</div>
		<div class="input-row">
			<div class="input-group-divider">
				<span>o regístrate con tu correo</span>
			</div>
		</div>
		<div class="input-row input-row-always-1-row">
			<div class="input-group-wrapper input-group-wrapper-50">
				<div
					class="input-group"
					:class="{ 'form-group--error': $v.firstName.$error }"
				>
					<label class="form__label" for="firstName">Nombre</label>
					<input
						class="form__input"
						type="text"
						id="firstName"
						name="firstName"
						v-model="firstName"
						ref="focusOnStart"
						v-on:keyup.enter="register()"
						:class="{ 'form-input--error': $v.firstName.$error }"
					/>
				</div>
				<div class="error-group" v-if="$v.firstName.$dirty">
					<div class="error" v-if="!$v.firstName.required">
						Ingresa tu nombre.
					</div>
					<div class="error" v-else-if="!$v.firstName.minLength">
						Nombre muy corto.
					</div>
					<div class="error" v-else-if="!$v.firstName.maxLength">
						Nombre no puede ser tan largo.
					</div>
					<div class="error" v-else-if="!$v.firstName.alpha">
						Nombre contiene caracteres inválidos.
					</div>
				</div>
			</div>
			<div class="input-group-wrapper input-group-wrapper-50">
				<div
					class="input-group"
					:class="{ 'form-group--error': $v.lastName.$error }"
				>
					<label class="form__label" for="lastName">Apellido</label>
					<input
						class="form__input"
						type="text"
						id="lastName"
						name="lastName"
						v-model="lastName"
						v-on:keyup.enter="register()"
						:class="{ 'form-input--error': $v.lastName.$error }"
					/>
				</div>
				<div class="error-group" v-if="$v.lastName.$dirty">
					<div class="error" v-if="!$v.lastName.required">
						Ingresa tu apellido.
					</div>
					<div class="error" v-else-if="!$v.lastName.minLength">
						Apellido muy corto.
					</div>
					<div class="error" v-else-if="!$v.lastName.maxLength">
						Apellido no puede ser tan largo.
					</div>
					<div class="error" v-else-if="!$v.lastName.alpha">
						Apellido contiene caracteres inválidos.
					</div>
				</div>
			</div>
		</div>
		<div class="input-group" :class="{ 'form-group--error': $v.email.$error }">
			<label class="form__label" for="email">Correo electrónico</label>
			<input
				class="form__input"
				type="email"
				id="email"
				name="email"
				v-model="email"
				v-on:keyup.enter="register()"
				:class="{ 'form-input--error': $v.email.$error }"
				@keydown.space.prevent
			/>
		</div>
		<div class="error-group" v-if="$v.email.$dirty">
			<div class="error" v-if="!$v.email.required">
				Ingresa tu correo electrónico.
			</div>
			<div class="error" v-else-if="!$v.email.email">
				Correo electrónico inválido.
			</div>
		</div>
		<div
			class="input-group"
			:class="{ 'form-group--error': $v.password.$error }"
		>
			<label class="form__label" for="password">Contraseña</label>
			<input
				class="form__input"
				type="password"
				id="password"
				name="password"
				v-model="password"
				v-on:keyup.enter="register()"
				:class="{ 'form-input--error': $v.password.$error }"
				@keydown.space.prevent
				v-if="!showPassword"
			/>
			<input
				class="form__input"
				type="text"
				id="password"
				name="password"
				v-model="password"
				v-on:keyup.enter="register()"
				:class="{ 'form-input--error': $v.password.$error }"
				@keydown.space.prevent
				v-else
			/>
			<i
				class="bx bx-show input-icon"
				@click="showPassword = !showPassword"
				v-if="showPassword"
			></i>
			<i
				class="bx bx-hide input-icon"
				@click="showPassword = !showPassword"
				v-else
			></i>
		</div>
		<div class="error-group" v-if="$v.password.$dirty">
			<div class="error" v-if="!$v.password.required">
				Ingresa tu contraseña.
			</div>
			<div
				class="error"
				v-else-if="
					!$v.password.minLength ||
					!$v.password.maxLength ||
					!$v.password.containsChar ||
					!$v.password.containsNum
				"
			>
				Debe contener al menos 8 caracteres y debe incluir al menos una letra y
				un número.
			</div>
		</div>
		<div class="input-row">
			<div class="input-group-wrapper input-group-wrapper-50">
				<div class="input-group" :class="{ 'form-group--error': $v.country.$error }">
					<label class="form__label" for="country">País</label>
					<v-select class="form__label" :options="countries" v-model="country" :components="{ OpenIndicator, Deselect }" :class="{ 'form-input--error': $v.country.$error }" :clearable="false" @input="calculateDocumentType">
						<div slot="no-options" style="font-size: 12px;">No se encontraron resultados.</div>
					</v-select>
				</div>
				<div class="error-group" v-if="$v.country.$dirty">
					<div class="error" v-if="!$v.country.required">Ingresa tu país.</div>
				</div>
			</div>
			<div class="input-group-wrapper input-group-wrapper-50">
				<div class="input-group" :class="{ 'form-group--error': $v.auxPhone.$error }">
					<label class="form__label" for="phone">Teléfono</label>
					<vue-phone-number-input class="form__input" name="phone" id="phone" v-model="auxPhone" :translations="phoneTranslations" :default-country-code="defaultCountryCode" :preferred-countries="['UY', 'AR']" :class="{ 'form-input--error': $v.auxPhone.$error }" :no-example="true" :no-validator-state="true" @update="phoneUpdated">
						<i class="bx bx-chevron-down" style="font-size: 20px;" slot="arrow"></i>
					</vue-phone-number-input>
				</div>
				<div class="error-group" v-if="$v.auxPhone.$dirty">
					<div class="error" v-if="!$v.auxPhone.required">Ingresa tu teléfono.</div>
					<div class="error" v-else-if="!$v.auxPhone.phoneValid">Teléfono incorrecto.</div>
				</div>
			</div>
		</div>
		<div class="input-row">
			<div class="input-group-wrapper input-group-wrapper-50">
				<div class="input-group" :class="{ 'form-group--error': $v.documentType.$error }">
					<label class="form__label" for="documentType">Tipo de documento</label>
					<v-select class="form__label" :options="documentTypes" v-model="documentType" :components="{ OpenIndicator, Deselect }" :class="{ 'form-input--error': $v.documentType.$error }" :clearable="false">
						<div slot="no-options" style="font-size: 12px;">No se encontraron resultados.</div>
					</v-select>
				</div>
				<div class="error-group" v-if="$v.documentType.$dirty">
					<div class="error" v-if="!$v.documentType.required">Ingresa tu tipo de documento.</div>
				</div>
			</div>
			<div class="input-group-wrapper input-group-wrapper-50">
				<div class="input-group" :class="{ 'form-group--error': $v.document.$error }">
					<label class="form__label" for="document">Documento</label>
					<input class="form__input" type="text" id="document" name="document" v-model="document" v-on:keyup.enter="register()" placeholder="Sin puntos ni guiones" :class="{ 'form-input--error': $v.document.$error }">
				</div>
				<div class="error-group" v-if="$v.document.$dirty">
					<div class="error" v-if="!$v.document.required">Ingresa tu documento.</div>
					<div class="error" v-else-if="!$v.document.minLength">Documento es incorrecto.</div>
				</div>
			</div>
		</div>
		<div class="error-area" v-if="registerError">
			<span>{{ registerError }}</span>
		</div>
		<button @click.prevent="register()" :disabled="submitingForm" v-if="!submitingForm">
			Crear mi cuenta
		</button>
		<button disabled="disabled" v-if="submitingForm">
			Creando cuenta <clip-loader class="registro-loader" :color="'var(--color-darker)'" :size="'12px'" ></clip-loader>
		</button>

		<div class="register-disclaimer">
			<span
				>Al registrarte, aceptas las <router-link :to="{ name: 'terminos-y-condiciones' }">Condiciones de servicio</router-link> de
				LineUp Tickets y reconoces que leíste nuestra
				<router-link :to="{ name: 'politica-de-privacidad' }">Política de privacidad</router-link>.</span
			>
			<div class="line"></div>
		</div>
		<p>
			¿Ya tienes una cuenta?<router-link :to="{ name: 'login' }"
				>Iniciar sesión</router-link
			>
		</p>
	</div>
</template>

<script>
	import axios from "axios";
	import {
		required,
		minLength,
		maxLength,
		email,
		helpers,
	} from "vuelidate/lib/validators";
	import { getFacebookUrl, getGoogleUrl } from "../utils";
	import SocialButton from "./SocialButton.vue";
	import { mapState } from "vuex";

	import VuePhoneNumberInput from 'vue-phone-number-input';
	import "vue-phone-number-input/dist/vue-phone-number-input.css";

	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	const alpha = helpers.regex(
		"alpha",
		/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/
	);

	export default {
		props: ["mode"],
		data() {
			return {
				registerError: null,
				googleUrl: getGoogleUrl(this.fromStateSocial),
				facebookUrl: getFacebookUrl(this.fromStateSocial),

				firstName: null,
				lastName: null,
				email: null,
				password: null,
				showPassword: false,
				documentType: null,
				document: null,
				phonePrefix: null,
				phone: null,
				auxPhone: null,
				country: null,

				submitingForm: false,

				timeZone: null,

				countries: [],
				documentTypes: [],

				OpenIndicator: {
					render: (createElement) =>
						createElement("i", {
							class: "bx bx-chevron-down",
							style: { "font-size": "20px" },
						}),
				},
				Deselect: {
					render: (createElement) =>
						createElement("i", {
							class: "bx bx-x",
							style: { "font-size": "18px" },
						}),
				},

				phoneTranslations: {
					phoneNumberLabel: "Teléfono",
				},
				defaultCountryCode: "UY",

				phoneValid: false,

				preUsuarioId: null,
			};
		},
		components: {
			'vue-phone-number-input': VuePhoneNumberInput,
			"social-button": SocialButton,
			ClipLoader
		},
		metaInfo: {
			title: 'Crear mi cuenta',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		validations: {
			firstName: {
				required,
				minLength: minLength(2),
				maxLength: maxLength(50),
				alpha,
			},
			lastName: {
				required,
				minLength: minLength(2),
				maxLength: maxLength(50),
				alpha,
			},
			email: {
				required,
				email,
			},
			password: {
				required,
				minLength: minLength(8),
				maxLength: maxLength(50),
				containsChar: function (value) {
					return /[a-zA-Z]/.test(value);
				},
				containsNum: function (value) {
					return /[0-9]/.test(value);
				},
			},
			auxPhone: {
				required,
				phoneValid: function () {
					return this.phoneValid;
				},
			},
			country: {
				required,
			},
			document: {
				required,
				minLength: minLength(6),
			},
			documentType: {
				required,
			},
		},
		computed: {
			...mapState([
				'fromStateSocial'
			])
		},
		async mounted() {
			this.$store.dispatch("cargando", true);
			this.$nextTick(() => this.$refs.focusOnStart.focus());

			await this.getCountries();
			await this.getDocumentTypes();
			await this.getCountryFromTimezone();

			this.$store.dispatch("cargando", false);
		},
		methods: {
			async getCountries() {
				this.countries = [];

				try {
					let response = await axios.post(
						'/WSPaises',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTPaises.map((p) => {
							let pais = {
								label: p.PaisNombre,
								code: p.PaisId,
								prefix: p.PaisTelefonoPrefijo,
							};
							this.countries.push(pais);
						});
					} else {
						await this.defaultCountries();
					}
				} catch (error) {
					await this.defaultCountries();
				}
			},
			async defaultCountries() {
				this.countries = [];

				let uru = {
					label: "Uruguay",
					code: "UY",
					prefix: 598,
				};
				this.countries.push(uru);

				let arg = {
					label: "Argentina",
					code: "AR",
					prefix: 54,
				};

				this.countries.push(arg);
			},
			async getCountryFromTimezone() {
				const ct = require("countries-and-timezones");
				this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

				const tz = ct.getTimezone(this.timeZone);
				const ctry = tz.countries[0];

				this.countries.map((c) => {
					if (c.code === ctry) {
						this.country = c;
					}
				});

				if (!this.country) {
					this.countries.map((c) => {
						if (c.code === "UY") {
							this.country = c;
						}
					});
				}

				await this.calculateDocumentType();
			},
			async getDocumentTypes() {
				this.documentTypes = [];

				try {
					let response = await axios.post(
						'/WSDocumentoTipos',
						{}
					);

					if (response.data.ErrorCod === 0) {
						response.data.SDTDocumentoTipos.map((d) => {
							let docType = {
								label: d.DocumentoTipoNombre,
								code: d.DocumentoTipoId,
							};
							this.documentTypes.push(docType);
						});
					}
				} catch (error) {
					console.log("No se encontraron tipos de documento");
				}
			},
			async calculateDocumentType() {
				if (this.country.code === "UY") {
					this.documentTypes.map((d) => {
						if (d.code === "1") {
							this.documentType = d;
						}
					});
				} else {
					this.documentTypes.map((d) => {
						if (d.code === "3") {
							this.documentType = d;
						}
					});
				}

				this.defaultCountryCode = this.country.code;
			},
			async register() {
				this.$store.dispatch("cargando", true);
				this.submitingForm = true;
				this.$v.$touch();

				if (!this.$v.$invalid) {
					this.registerError = null;

					try {
						let response = await axios.post(
							'/WSRegistro',
							{
								PreUsuarioEmail: this.email,
								PreUsuarioPassword: this.password,
								PreUsuarioNombre: this.firstName.trim(),
								PreUsuarioApellido: this.lastName.trim(),
								PreUsuarioDocumentoTipoId: parseInt(this.documentType.code),
								PreUsuarioDocumento: this.document.trim(),
								PrePaisId: this.country.code,
								PreUsuarioTelefonoPrefijo: this.phonePrefix.trim(),
								PreUsuarioTelefono: this.phone.trim(),
							}
						);

						if (response.data.ErrorCod === 0) {
							this.preUsuarioId = response.data.PreUsuarioId;
							this.$store.dispatch("cargando", false);
							this.$router.push({
								name: "verify-email",
								params: { preUsuarioId: this.preUsuarioId },
							});
						} else {
							this.registerError = response.data.ErrorDsc;
						}
					} catch (error) {
						this.registerError = "Ocurrió un error al registrarse";
					}
				}

				this.submitingForm = false;
				this.$store.dispatch("cargando", false);
			},
			async phoneUpdated(payload) {
				if (payload.nationalNumber) {
					let phone = payload.nationalNumber;
					let phonePrefix = payload.countryCallingCode;
					let isValid = payload.isValid;

					this.phoneValid = isValid;

					if (isValid) {
						// this.phone = phone.trim().replace(/ /g, '')
						this.phone = phone.trim();
						this.phonePrefix = phonePrefix;
					} else {
						this.phone = null;
						this.phonePrefix = null;
					}
				} else {
					this.phone = null;
					this.phonePrefix = null;
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.register-form {
		width: 100%;
		padding: 0px;
		@include flex(column, center, flex-start);
		position: relative;

		.lineup-home{
			display: none;
			text-decoration: none;
			cursor: pointer;
			margin-bottom: 20px;

			.logo-lineup{
				height: 42px;
				width: auto;
			}
		}

		.register-title {
			font-family: var(--font-sora);
			font-weight: var(--fw-700);
			font-size: 26px;
			margin-bottom: 7px;
		}

		.register-subtitle {
			font-weight: var(--fw-400);
			font-size: 14px;
			margin-bottom: 15px;
			line-height: 1.6em;
		}

		.input-row {
			width: 100%;
			margin: 0px;
			@include flex(row, space-between, flex-start);

			.input-group-wrapper {
				width: 100%;
				margin: 5px 0px;
				padding: 0px;
				position: relative;
				@include flex(column, center, flex-start);

				&.input-group-wrapper-50 {
					width: calc(50% - 8px);
				}
			}

			.input-group-divider {
				width: 100%;
				@include flex(row, center, center);
				position: relative;
				margin: 7px 0px;

				span {
					line-height: 1em;
					background-color: var(--color-white);
					padding: 4px 6px;
					z-index: 1;
					font-size: 11px;
				}

				&:after {
					content: "";
					position: absolute;
					height: 0.5px;
					width: 100%;
					background-color: #cfcfcf;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
		}

		.input-group {
			width: 100%;
			margin: 5px 0px 4px 0px;
			position: relative;
			@include flex(column, flex-end, flex-start);

			label {
				font-size: 13px;
				font-weight: var(--fw-600);
				margin-top: 0px;
				margin-bottom: 5px;
				line-height: 1em;
			}

			input {
				-webkit-appearance: none;
				appearance: none;
				border: none;
				width: 100%;
				padding: 0px 36px 0px 14px;
				font-size: 14px;
				font-weight: var(--fw-400);
				line-height: 1.4em;
				width: 100%;
				border-radius: 8px;
				height: 44px;
				outline: none;
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
				// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

				&::placeholder {
					color: #9aa5b5;
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: #9aa5b5;
				}

				&::-ms-input-placeholder {
					color: #9aa5b5;
				}

				&:focus-within {
					@include transition(all 0.2s);
					box-shadow: #222 0px 0px 0px 2px inset;

					&.form-input--error {
						box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
					}
				}

				&.form-input--error {
					box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
				}
			}

			input:-webkit-autofill,
			input:-webkit-autofill:hover,
			input:-webkit-autofill:focus,
			textarea:-webkit-autofill,
			textarea:-webkit-autofill:hover,
			textarea:-webkit-autofill:focus,
			select:-webkit-autofill,
			select:-webkit-autofill:hover,
			select:-webkit-autofill:focus {
				border: none;
				-webkit-text-fill-color: var(--color-darker);
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
					0 0 0px 1000px var(--color-white) inset;
				-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
					0 0 0px 1000px var(--color-white) inset;

				&:focus-within {
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset,
						0 0 0px 1000px var(--color-white) inset;
				}
			}

			.input-icon {
				position: absolute;
				color: rgb(176, 176, 176);
				bottom: 12px;
				font-size: 20px;
				right: 12px;
				cursor: pointer;

				&:hover {
					@include transition(all 0.2s);
					color: var(--color-darker);
				}
			}

			&.form-group--error {
				label {
					color: var(--color-red-error);
				}
			}
		}

		.error-group {
			width: 100%;
			@include flex(column, center, flex-start);

			.error {
				font-size: 11px;
				color: var(--color-red-error);
				line-height: 1em;
			}
		}

		button {
			background-color: #222222;
			border: none;
			border-radius: 8px;
			outline: none;
			padding: 14px;
			width: 100%;
			color: var(--color-white);
			font-size: 14px;
			font-weight: var(--fw-600);
			font-family: var(--font-sora);
			line-height: 1.4em;
			letter-spacing: 1px;
			margin-top: 14px;
			@include transition(all 0.2s);
			cursor: pointer;
			@include flex(row, center, center);

			&:hover {
				background-color: var(--color-black);
			}

			&:disabled {
				background-color: #e8e9eb;
				color: var(--color-darker);
				border-color: #e8e9eb;
				cursor: not-allowed;
			}
		}

		.registro-loader{
			margin-left: 10px;
			margin-bottom: -3px;
		}

		.error-area {
			width: 100%;
			@include flex(row, flex-start, center);
			padding: 12px;
			margin-top: 10px;
			border-radius: 8px;
			background: rgb(255, 243, 243);

			span {
				color: rgb(242, 53, 53);
				font-size: 14px;
				font-weight: var(--fw-500);
			}
		}

		p {
			font-weight: var(--fw-600);
			font-size: 13px;
			text-align: center;
			width: 100%;
			margin-top: 15px;

			a {
				margin-left: 5px;
				color: var(--color-darker);
				text-decoration: underline;
			}
		}

		.register-disclaimer {
			width: 100%;
			margin-top: 15px;
			@include flex(column, flex-start, center);

			span {
				font-size: 11px;
				text-align: center;
				width: 80%;
				padding-bottom: 15px;
				line-height: 1.5em;
				color: #9aa5b5;

				a {
					color: var(--color-darker);
					font-weight: var(--fw-600);
				}
			}

			.line {
				width: 30%;
				background-color: var(--color-border);
				height: 1px;
			}
		}
	}

	@media screen and (max-width: 968px){
		.register-form{
			.lineup-home{
				@include flex(row, flex-start, center);
			}
		}
	}

	@media screen and (max-width: 450px){
		.register-form{
			.register-title{
				font-size: 22px;
			}

			.input-row{
				@include flex(column, flex-start, flex-start);
				
				.input-group-wrapper{
					&.input-group-wrapper-50{
						width: 100%;
						margin: 0;
					}
				}

				&.input-row-always-1-row{
					@include flex(row, space-between, flex-start);

					.input-group-wrapper{
						width: calc(50% - 6px);
					}
				}
			}

			.register-disclaimer{
				span{
					width: 100%;
				}
			}
		}
	}

	@media screen and (max-height: 810px){
		.register-form{
			.register-title{
				font-size: 22px;
			}

			.input-group{
				margin: 4px 0px 3px 0px;
				label {
					font-size: 12px;
					margin-bottom: 4px;
				}

				input{
					height: 40px;
					font-size: 13px;
				}
			}

			button{
				margin-top: 10px;
				font-size: 14px;
				padding: 12px;
			}

			p{
				margin-top: 12px;
			}

			.register-disclaimer{
				span{
					width: 100%;
					padding-bottom: 12px;
				}
			}
		}
	}
</style>
